module.exports = __webpack_public_path__ + "fonts/SFCompactDisplay-Black.d392f5c.otf";